<template>
    <div>
        
        <!-- Encabezado de la Aplicación -->
        <div class="appHeader no-border transparent position-absolute">
            <div class="left">
                <a href="#" class="headerButton goBack">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle"></div>
            <div class="right">
                <router-link :to="{ name: 'login' }" class="headerButton">
                    Iniciar sesión
                </router-link>
            </div>
        </div>
        <!-- * Encabezado de la Aplicación -->

        <!-- Cápsula de la Aplicación -->
        <div id="appCapsule">

            <div class="section mt-2 text-center">
                <h1>Regístrese ahora</h1>
                <h4>Cree una cuenta</h4>
            </div>
            <div class="section">
                <p v-if="errors.length">
                    <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
                    <!-- <ul><li v-for="(error, e) in errors" v-bind:key="'e-'+e">{{ error }}</li></ul> -->
                </p>
            </div>
            <div class="section mb-5 p-2">
                <form @submit.prevent="checkForm">
                    <div class="card">
                        <div class="card-body">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="username1">Usuario</label>
                                    <input type="text" class="form-control" id="username1" placeholder="Usuario" v-model="username" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="email1">Correo electrónico</label>
                                    <input type="text" class="form-control" id="email1" placeholder="Su correo electrónico" v-model="email" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="password1">Contraseña</label>
                                    <input type="password" class="form-control" id="password1" autocomplete="off" placeholder="Su contraseña" v-model="password" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="password2">Contraseña de nuevo</label>
                                    <input type="password" class="form-control" id="password2" autocomplete="off" placeholder="Ingrese la contraseña de nuevo" v-model="passwordC" required />
                                    <i class="clear-input">
                                        <ion-icon name="close-circle"></ion-icon>
                                    </i>
                                </div>
                            </div>
                            <div class="custom-control custom-checkbox mt-2 mb-1">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="customCheckb1" required="on">
                                    <label class="form-check-label" for="customCheckb1">
                                        Acepto los <a href="#" data-bs-toggle="modal" data-bs-target="#termsModal">términos y condiciones</a>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-button-group transparent">
                        <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="sending">Registrarse</button>
                    </div>
                </form>
            </div>
        </div>
        <!-- * Cápsula de la Aplicación -->

        <!-- Modal de Términos -->
        <div class="modal fade modalbox" id="termsModal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Términos y condiciones</h5>
                        <a href="#" data-bs-dismiss="modal">Cerrar</a>
                    </div>
                    <div class="modal-body">
                        <docs-terms-and-condictions />
                    </div>
                </div>
            </div>
        </div>
        <!-- * Modal de Términos -->

    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    data() {
        return {
            sending: false,
            username: null,
            email: null,
            password: null,
            passwordC: null,
            errors: [],
        };
    },
    mounted() {
        this.$root.loadBackButtom();
        this.$root.loadInputs();
    },
    methods: {
        ...mapActions(['v1_registerAPI']),
        async checkForm() {
            this.sending = true;
            if (this.username && this.email && this.password && this.passwordC) {
                const isUser = await this.v1_registerAPI({username: this.username, email:this.email, password:this.password});   
                console.log('Registrando', isUser)
                if (isUser == true) this.$router.push({name:'login'})
                if (isUser == true) location.replace('/login')
            }
            this.sending = false;
        }
    }
}
</script>